/**
 * Shared content-column widths for the app's centered spine.
 *
 * The app ships iOS, Android, and web. On wide viewports (desktop web, tablets)
 * an unconstrained content column stretches edge-to-edge, producing 100+ char
 * line lengths and a "blown-up phone" feel. These widths clamp the primary
 * surfaces to a readable, centered column.
 *
 * The clamp keys off *available width*, not the responsive-breakpoint hook, so
 * it also engages on native tablets (where the native breakpoint hook always
 * reports `'mobile'`) and is a no-op on phones narrower than the max.
 */

/** Reading/social spine: activity feed, profile, business detail. */
export const CONTENT_MAX_WIDTH = 600;

/** Browse column: discover (wider so its horizontal rails breathe). */
export const BROWSE_MAX_WIDTH = 760;

/**
 * Form column: auth screens and the `(setup)` group. Narrower than the reading
 * spine because a stack of full-width inputs at 600px reads as a stretched
 * phone, and because auth and setup are one continuous flow -- sharing the
 * constant is what keeps the column from changing width between sign-up and
 * the last onboarding step.
 */
export const FORM_MAX_WIDTH = 420;

/**
 * Style to clamp and center a content column. Spread into a FlatList/ScrollView
 * `contentContainerStyle`, or apply to a wrapper `View`.
 */
export const centeredContent = (maxWidth: number) =>
  ({ width: '100%', maxWidth, alignSelf: 'center' }) as const;
